import React, { useState, useEffect, useRef } from 'react'
import { InputDiv, Label, Input, SearchOptions, Option } from '../../styles/select-style'
import ApiService from '../../../services/ApiService'
import { ParamItemType } from './types'
import { CertificateType } from '../../../pages/ClientPanel/Certificates/CreateCertificate'

type PropsType = {
  certificate: CertificateType,
  setCertificate: React.Dispatch<React.SetStateAction<CertificateType>>,
  structuringCompleted: boolean
}

const SelectParamInCertificate: React.FC<PropsType> = ({certificate, setCertificate, structuringCompleted}) => {
  const [ items, setItems ] = useState<{id:number, name:string, type:{id:number, name:string}}[]>([])
  const [ inputItem, setInputItem ] = useState<string>('')
  const [ showOptions, setShowOptions ] = useState<boolean>(false)
  const [ selectedIndex, setSelectedIndex ] = useState(0)
  const inputRef = useRef<HTMLInputElement>(null)
  const optionsRef = useRef<HTMLUListElement>(null)
  
  useEffect(() => {
    setInputItem(certificate.param.name)
  }, [certificate.param.id])

  useEffect(() => {
    setSelectedIndex(0)
    const handle = setTimeout(() => {
      ApiService.certificates.getParams({ query: inputItem })
        .then((response: any) => {
          if(response.data) setItems(response.data)
        })
        .catch((error: any) => {
          console.log(error)
        })
    }, 300)

    return () => clearTimeout(handle)
  }, [inputItem])
  
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node
      if (
        optionsRef.current &&
        inputRef.current &&
        !optionsRef.current.contains(target) &&
        !inputRef.current.contains(target)
      ) {
        setShowOptions(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputItem(e.target.value)
  }

  const handleSelectItem = (item: {id:number, name:string, type:{id:number, name:string}}) => {
    setInputItem(item.name)
    setShowOptions(false)
    setCertificate((prev: CertificateType) => ({
      ...prev,
      param:item
    }))
  }

  const handleSetOptionByKey = (e:React.KeyboardEvent) => {
    if(e.key === 'ArrowDown' && selectedIndex < items.length - 1) setSelectedIndex(prev => prev + 1)
    if(e.key === 'ArrowUp' && selectedIndex > 0) setSelectedIndex(prev => prev - 1)
    if(e.key === 'Enter') handleSelectItem(items[selectedIndex])
    if(e.key === 'Tab') setShowOptions(false)
  }

  return(
    <InputDiv>
      <Label>Parâmetro</Label>
      <Input 
        ref={inputRef}
        type='text' 
        placeholder='Selecione'
        value={inputItem}
        onFocus={() => setShowOptions(true)}
        onChange={handleChangeInput}
        onKeyDown={(e) => handleSetOptionByKey(e)}
        disabled={structuringCompleted}
      />
      {showOptions && 
        <SearchOptions ref={optionsRef}>
          {items.map((item, index) => 
            <Option 
              key={index}
              onClick={() => handleSelectItem(item)}
              isSelected={index === selectedIndex}
            >
              {item.name}
            </Option>
          )}
        </SearchOptions>
      }
    </InputDiv>
  )
}

export default SelectParamInCertificate

